import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector, useDispatch } from 'react-redux';

import actions from '@/actions';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';

const useEditorMarkers = () => {
  const dispatch = useDispatch();
  const commands = useSelector((state) => state.mission.json.commands);

  useUpdateEffect(() => {
    const draftMarkers = [];
    let labelNumber = 1;

    commands.forEach((command) => {
      switch (command.type) {
        case 'navLand':
          draftMarkers.push({
            id: command.id,
            label: labelNumber,
            position: command.data.position,
            relAltitude: draftMarkers.at(-1).relAltitude,
            mslAltitude: draftMarkers.at(-1).mslAltitude,
            draggable: true,
          });

          // Parachute 항목 체크한 경우
          if (command.data.parachute) {
            labelNumber += 3; // Waypoint, Parachute Enable, Release 반영
          }
          break;

        case 'doSetRoiLocation':
        case 'navLoiterTime':
        case 'navLoiterToAlt':
        case 'navLoiterTurns':
        case 'navTakeoff':
          draftMarkers.push({
            id: command.id,
            label: labelNumber,
            position: command.data.position,
            relAltitude: command.data.altitude,
            mslAltitude: commands[0].data.elevation + command.data.altitude,
            draggable: true,
          });
          break;

        case 'navWaypoint':
          draftMarkers.push({
            id: command.id,
            label: labelNumber,
            position: command.data.position,
            relAltitude: command.data.altitude,
            mslAltitude: commands[0].data.elevation + command.data.altitude,
            draggable: true,
          });

          // Speed 항목 체크한 경우
          if (command.data.speed) {
            labelNumber++; // Change Speed 반영
          }
          break;

        case 'navReturnToLaunch':
          draftMarkers.push({
            id: command.id,
            label: labelNumber,
            position: commands[0].data.position,
            relAltitude: draftMarkers.at(-1).relAltitude,
            mslAltitude: draftMarkers.at(-1).mslAltitude,
            draggable: false,
          });
          break;

        case 'cusSurvey':
          {
            const surveyCommand = getCommandForSurveySegment(command);
            const startLabel = labelNumber;
            const endLabel = labelNumber + surveyCommand.data.positions.length - 1;
            const mslAltitude = commands[0].data.elevation + command.data.altitude;

            // 서베이 시작점
            draftMarkers.push({
              id: `${surveyCommand.id}/survey/start`,
              label: startLabel,
              position: surveyCommand.data.positions.at(0),
              relAltitude: command.data.altitude,
              mslAltitude,
              draggable: false,
            });

            // 서베이 종료점
            draftMarkers.push({
              id: `${surveyCommand.id}/survey/end`,
              label: endLabel,
              position: surveyCommand.data.positions.at(-1),
              relAltitude: command.data.altitude,
              mslAltitude,
              draggable: false,
            });

            labelNumber = endLabel;
          }
          break;

        default:
          break;
      }

      labelNumber++;
    });

    const markers = Object.fromEntries(
      draftMarkers.map((marker) => {
        const { id, ...data } = marker;
        return [id, data];
      }),
    );

    dispatch(actions.editor.loadMarkers(markers));
  }, [commands]);
};

export default useEditorMarkers;
